var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Row } from "react-bootstrap";
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", "\n  padding-right: 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  ", "\n  padding-right: 20px;\n"])), function (_a) {
    var leftAlign = _a.leftAlign;
    return !leftAlign && "justify-content: center;";
});
export var Title = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
export var StyledRow = styled(Row)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 10px;\n"], ["\n  margin-bottom: 10px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
